import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shift-view',
  templateUrl: './shift-view.component.html',
  styleUrls: ['./shift-view.component.css']
})
export class ShiftViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
